var $ = require('jquery');
var Auth = require('Authentication');

var Configuration = EY.Consultation.Lookups.Configuration; 
var Session = Backbone.Model.extend({
    constructor: function () {
        setTimeout(this.timeout, Configuration.SessionTimeout, this);
        Backbone.Model.apply(this, arguments);
    },
    defaults: {
        time: new Date(),
        active: new Date()
    },
    timeout: function (session) {
        session.set('time', new Date());
    },
    timeChanged: function () {
        var inactive = this.inactive();
        if (this.inactive() >= Configuration.SessionTimeout) {
            window.location = 'Consultation/SessionTimeout?culture=' + EY.Consultation.CurrentCulture;
        } else {
            setTimeout(this.timeout, Configuration.SessionTimeout - inactive, this);
        }
    },
    inactive: function() {
        return this.get('time').getTime() - this.get('active').getTime();
    },
    closeSession: function() {
        Auth.logout();
    }
});

module.exports.run = function () {
    var session = EY.Consultation.CurrentUser.session = new Session();
    
    $('body').bind('click keypress', function () {
        session.set('active', new Date());
    });
    session.on('change:time', session.timeChanged);
};

module.exports.close = function () {
    EY.Consultation.CurrentUser.session.closeSession();
}


// WEBPACK FOOTER //
// ./js/Modules/Service/Session.js